export default "__VITE_ASSET__CVlwMkf9__"